/**
 * Belgeleri API'den getirir
 *
 * @param {Object} options - Yapılandırma seçenekleri
 * @param {Object} options.axios - Axios örneği
 * @param {Object} options.settings - URL ayarları
 * @param {String} options.assetId - Geçerli varlık ID'si
 * @param {Object} options.filters - Filtre parametreleri
 * @param {String} options.searchQuery - Arama terimi
 * @param {Object} options.sort - Sıralama parametreleri
 * @returns {Promise<Array>} - Belge verileri
 */
export const fetchDocuments = async (options) => {
  const { axios, settings, assetId, filters = {}, searchQuery = '', sort = {} } = options

  // Filtrelerle sorgu parametrelerini hazırla
  const params = {
    assetId,
  }

  // Filtreleri ekle
  if (filters.fileType) {
    params.typeId = filters.fileType
  }

  if (filters.categoryId) {
    params.categoryId = filters.categoryId
  }

  if (searchQuery.trim()) {
    params.searchTerm = searchQuery.trim()
  }

  // Tarih filtrelerini işle
  if (filters.dateFilter && filters.dateRange) {
    const { startDate, endDate } = filters.dateRange

    if (startDate && endDate) {
      params.startDate = startDate
      params.endDate = endDate
    }
  }

  // Sıralama ekle - varsayılan değer olarak tarih ve azalan sıralama
  params.sortBy = sort.field || 'addDate'
  params.sortDirection = sort.direction || 'desc'

  try {
    const response = await axios.get(settings.getDocumentFiles, { params })
    return response.data.data
  } catch (error) {
    console.error('Belgeler getirilirken hata oluştu:', error)
    throw error
  }
}